import { fetchUserCreditsWallet } from './creditsService';

export const validateCreditsForAction = async (actionType, requiredAmount) => {
	const { data: wallet, error } = await fetchUserCreditsWallet();

	if (error || !wallet) {
		return {
			hasEnoughCredits: false,
			error: 'Credits konnten nicht geladen werden',
		};
	}

	let availableCredits;
	let creditType;

	switch (actionType) {
		case 'googleMapsSearch':
		case 'hrDetailsSearch':
		case 'localHrSearch':
			availableCredits = wallet.companyCredits;
			creditType = 'Firmen';
			break;
		case 'leadEnrichment':
			availableCredits = wallet.contactCredits;
			creditType = 'Kontakt';
			break;
		default:
			return {
				hasEnoughCredits: false,
				error: 'Unbekannter Action-Typ',
			};
	}

	const hasEnoughCredits = availableCredits >= requiredAmount;

	return {
		hasEnoughCredits,
		availableCredits,
		requiredAmount,
		creditType,
		error: hasEnoughCredits
			? null
			: `Nicht genügend ${creditType}-Credits. Benötigt: ${requiredAmount}, Verfügbar: ${availableCredits}`,
	};
};
